const base = '/banner',
    basePath = `pages${base}`;
export default [
  {
    path:`${base}/index`,
    name:'bannerIndex',
    component:r => require.ensure([], () => r(require(`@/${basePath}/index`)), 'bannerIndex'),
    meta:{
      tit:'banner管理'
    }
  },
  {
    path:`${base}/edit`,
    name:'bannerEdit',
    component:r => require.ensure([], () => r(require(`@/${basePath}/edit`)), 'bannerEdit'),
    meta:{
      tit:'banner编辑'
    }
  },
]


// WEBPACK FOOTER //
// ./src/router/router/banner.js